import { Organization } from '@robocorp/robocloud-internal-cds-sdk';

export const isOrgDisabled = (state: Organization['state']) => state === 'disabled';

export const isOrgBillingNotPaid = (billingState: Organization['billing_state']) =>
  billingState !== 'paid';

export const isOrgOutOfRunMinutes = (runMinutesState: Organization['rmin_state']) =>
  runMinutesState === 'overflow';

export const isOrgOutOfAssistantRuns = (assistantRunState: Organization['assrun_state']) =>
  assistantRunState === 'overflow';

/**
 * Better way to check this would be to pull full plan info and check if it's inactive,
 * but making this request this early in app loading cycle seems wasteful.
 */
export const isOrgOnInactiveTier = (tierId: Organization['subscription_tier_id']) => {
  const tierIdSafe = tierId ?? '';
  if (
    tierIdSafe.startsWith('partner') ||
    tierIdSafe.startsWith('pro') ||
    tierIdSafe.startsWith('custom') ||
    tierIdSafe.includes('enterprise') ||
    tierIdSafe.includes('prepaid') ||
    tierIdSafe.includes('consumption')
  ) {
    return false;
  }
  const planNumber = Number(tierIdSafe.match(/\d+$/)?.[0]) || 0;
  return planNumber < 20;
};
